export enum AppealStatusesEnum {
  SEND = 'SEND',
  PARTIALLY_APPROVE = 'PARTIALLY_APPROVE',
  DENIED = 'DENIED',
  CONTROL = 'CONTROL',
  APPROVE = 'APPROVE',
}
